<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title 
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Meta Financeira"
      ></page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>
        <div class="row teste">
          <div class="col-md-6 col-sm-12 mb-3">
            <anosafra-multiselect
              v-model="filter.anosafra"
              label="Ano Safra"
              required
              rules="required"
            />
          </div>
          <div class="col-md-6 col-sm-12 mb-3">
            <label class="form-control-label">Tipo<span class="text-danger">*</span></label>
            <multiselect
              placeholder="Selecione o tipo"
              v-model="filter.goalType"
              :options="goalTypes"
              label="label"
              track-by="value"
              rules="required"
            />
          </div>       
          <div class="col-6" v-if="jobAssociatedType">
            <label class="form-control-label"> {{ filter.goalType.label }}</label>
            <multiselect
              placeholder="Selecione o(s) Usuário(s)"
              v-model="filter.seed_manager"
              :options="jobAssociatedUsers"
              :loading="isLoadingSeedManagers"
              label="name"
              track-by="id"
              :limit="1"
              :limit-text="limitText"
              :multiple="true"
            />
          </div>
          <div class="col-6" v-if="selectedGoalTypeValue != 'salesman' && selectedGoalTypeValue != 'admin' && !jobAssociatedType">
            <label class="form-control-label">Gerente Comercial</label>
            <multiselect
              placeholder="Selecione o Gerente Comercial"
              v-model="filter.manager"
              :options="filteredManager"
              :loading="loadingManager"
              label="name"
              track-by="id"
              @input="filterSalesmen"
              :disabled="!currentUser.is_admin"
              :multiple="true"
              :close-on-select="false"
              :limit="1"
              :limit-text="limitText"
            />
          </div>
          <div class="col-md-6 col-sm-12 mb-3">
            <label class="form-control-label">Até</label>
            <multiselect
              v-model="filter.dateLimit"
              :options="dateLimit"
              placeholder="Selecione Limite"
              :show-no-options="false"
            />
          </div>

          <div class="col-md-6 col-sm-12 mb-3">
            <label class="form-control-label">Tipo meta<span class="text-danger">*</span></label>
            <multiselect
              v-model="filter.tableName"
              :options="tableName"
              placeholder="Selecione a tabela"
              :show-no-options="false"
              :multiple="true"
              :close-on-select="false"
              :limit="1"
              :limit-text="limitText"
              rules="required"
            />
          </div>
          <div class="col-lg-6 col-12 mb-3" v-if="selectedGoalTypeValue == 'salesman' || selectedGoalTypeValue == 'manager' ">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              placeholder="Selecione o Vendedor"
              v-model="filter.salesman"
              :options="filteredSalesmen"
              :loading="loadingSalesmen"
              label="name"
              track-by="id"
              :disabled="!currentUser.is_admin && !currentUser.is_manager"
              :multiple="true"
              :close-on-select="false"
              :limit="1"
              :limit-text="limitText"
            />
          </div>
        </div>
        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" v-loading="loadingPdf" @click="generatePDF">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2" v-loading="loadingExcel" @click.prevent="startDownloadXlsx()">Gerar Excel</base-button>
          <el-tooltip :disabled="!isButtonDisabled" content="Preencha os campos obrigatórios antes de continuar." placement="top">
            <base-button :disabled="isButtonDisabled" type="primary" class="ml-2 mt-2" @click="generateReportBefore(false)" v-loading="isLoading">
              Gerar Relatório
            </base-button>
          </el-tooltip>
        </div>
      </card>
    </div>

    <card
      v-if="showVersionsSelect"
    >
      <button 
        type="button" 
        class="close"
        @click="() => showVersionsSelect = false"
      >
        <span >×</span>
      </button>
     
      <report-version-select
        report-type="Goals"
        @generate-report="generateReportByVersion"
        @save-report="generateReportBefore(true)"
      />
    </card>

    <card v-show="Object.keys(tableData).length" ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          ({{ anosafra.descricao }}) Meta Financeira - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6 class="text-muted ls-1 mb-1 text-uppercase">
          Vendedor - 
          <span>
            {{ salesmanName.map(user => `${user.name}`).join(' / ') }}
          </span>
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          ({{ anosafra.descricao }}) Meta Financeira - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.goalType && Object.keys(filter.goalType).length"
        >
          Tipo de Meta: {{ filter.goalType.label }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anosafra && Object.keys(filter.anosafra).length"
        >
          Ano Safra: {{ anosafra.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.salesman && Object.keys(filter.salesman).length"
        >
          Vendedor: {{ filter.salesman.name }}
        </h6>
        <br />
        <br />
        <br />
      </div>

      <card v-for="(data, index) in tableDataArray" v-if="data.user" :key="`${data.user.id}-${index}`">
        <el-table
          :data="data.goals.goal"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column label="META" v-if="filter.tableName.includes('Meta') || filter.tableName.includes('TODAS')">
            <template #header>
              <span>({{ anosafra.descricao }}) META - {{ lastEdition | formatDate("full") }} </span>
            </template>
            <el-table-column :label="userInfo(data)">
              <el-table-column
                label="Grupo"
                min-width="125px"
                prop="group"
                sortable
              />
              <el-table-column
                v-slot="{ row }"
                label="Meta"
                prop="salesman_goal"
                min-width="125px"
                sortable
              >
                {{
                  row.salesman_goal
                    ? row.salesman_goal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    : "0".toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                }}
              </el-table-column>
              <el-table-column
                v-slot="{ row }"
                label="Realizada"
                prop="salesman_sales"
                min-width="125px"
                sortable
              >
                {{
                  row.salesman_sales
                    ? row.salesman_sales.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    : 0
                }}
              </el-table-column>
              <el-table-column
                :formatter="numberFormatter"
                label="Meta Atingida"
                min-width="125px"
                prop="salesman_percentage"
                v-slot="{ row }"
                sortable
              >
              {{ row.salesman_percentage.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}%
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <br />
        <br />

        <el-table
          :data="data.goals.goal_plus_balance"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          show-summary
          :summary-method="getSummaries"
        >
         <el-table-column label="META + SALDO EM CARTEIRA"  v-if="filter.tableName.includes('Meta + Saldo em Carteira') || filter.tableName.includes('TODAS')">
            <template #header>
              <span>({{ anosafra.descricao }}) META + SALDO EM CARTEIRA - {{ lastEdition | formatDate("full") }}</span>
            </template>
            <el-table-column :label="userInfo(data)">
              <el-table-column
                label="Grupo"
                min-width="125px"
                prop="group"
                sortable
              />
              <el-table-column
                v-slot="{ row }"
                label="Meta"
                prop="salesman_goal"
                min-width="125px"
                sortable
              >
                {{
                  row.salesman_goal
                    ? row.salesman_goal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    : "0".toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                }}
              </el-table-column>
              <el-table-column
                v-slot="{ row }"
                label="Realizada"
                prop="salesman_sales"
                min-width="125px"
                sortable
              >
                {{
                  row.salesman_sales
                    ? row.salesman_sales.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    : 0
                }}
              </el-table-column>
              <el-table-column
                :formatter="numberFormatter"
                label="Meta Atingida"
                min-width="125px"
                prop="salesman_percentage"
                v-slot="{ row }"
                sortable
              >
              {{ row.salesman_percentage.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}%
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <br />
        <br />
        <el-table
          :data="data.goals.strategic_goal"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column label="META ESTRATÉGICA" v-if="filter.tableName.includes('Meta Estratégica') || filter.tableName.includes('TODAS')">
            <template #header>
              <span>({{ anosafra.descricao }}) META ESTRATÉGICA - {{ lastEdition | formatDate("full") }}</span>
            </template>
            <el-table-column :label="userInfo(data)">
              <el-table-column
                label="Grupo"
                min-width="125px"
                prop="group"
                sortable
              />
              <el-table-column
                v-slot="{ row }"
                label="Meta"
                prop="salesman_goal"
                min-width="125px"
                sortable
              >
                {{
                  row.salesman_goal
                    ? row.salesman_goal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    : "0".toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                }}
              </el-table-column>
              <el-table-column
                v-slot="{ row }"
                label="Realizada"
                prop="salesman_sales"
                min-width="125px"
                sortable
              >
                {{
                  row.salesman_sales
                    ? row.salesman_sales.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    : 0
                }}
              </el-table-column>
              <el-table-column
                :formatter="numberFormatter"
                label="Meta Atingida"
                min-width="125px"
                prop="salesman_percentage"
                v-slot="{ row }"
                sortable
              >
              {{ row.salesman_percentage.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}%
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
        <br />
        <br />
        <el-table
          :data="data.goals.strategic_goal_plus_balance"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column label="META ESTRATÉGICA + SALDO EM CARTEIRA"  v-if="filter.tableName.includes('Meta Estratégica + Saldo em Carteira') || filter.tableName.includes('TODAS')">
            <template #header>
              <span>({{ anosafra.descricao }}) META ESTRATÉGICA + SALDO EM CARTEIRA - {{ lastEdition | formatDate("full") }}</span>
            </template>
            <el-table-column :label="userInfo(data)">
              <el-table-column
                label="Grupo"
                min-width="125px"
                prop="group"
                sortable
              />
              <el-table-column
                v-slot="{ row }"
                label="Meta"
                prop="salesman_goal"
                min-width="125px"
                sortable
              >
                {{
                  row.salesman_goal
                    ? row.salesman_goal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    : "0".toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                }}
              </el-table-column>
              <el-table-column
                v-slot="{ row }"
                label="Realizada"
                prop="salesman_sales"
                min-width="125px"
                sortable
              >
                {{
                  row.salesman_sales
                    ? row.salesman_sales.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    : 0
                }}
              </el-table-column>
              <el-table-column
                :formatter="numberFormatter"
                label="Meta Atingida"
                min-width="125px"
                prop="salesman_percentage"
                v-slot="{ row }"
                sortable
              >
              {{ row.salesman_percentage.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}%
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
      </card>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import { Table, TableColumn } from "element-ui";
import Card from '../../components/Cards/Card.vue';
import ReportVersionSelect from "../../components/ReportVersionSelect.vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
}); 

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    Card,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    ReportVersionSelect
},
  data() {
    return {
      active: true,
      filter: {
        anosafra: {},
        goalType: { label: 'Vendedores', value: 'salesman' },
        salesman: [],
        dateLimit: null,
        tableName: [],
        grupo_id: [],
        manager: [],
        seed_manager: [],
        seed_coordinated: [],
        selectedOptions: [],
      },
      isLoadingCoordinators: false,
      isLoadingSeedCoordinators: false,
      isLoadingMktMananagers: false,
      isLoadingSeedManagers: false,
      options: {
        tableName :[
          'META',
          'META + SALDO EM CARTEIRA',
          'META ESTRATÉGICA',
          'META ESTRATÉGICA + SALDO EM CARTEIRA',
          'TODAS'
        ],
      },
      salesmen: [],
      mkt_managers: [],
      coordinateds: [],
      filteredSalesmen: [],
      filteredManager: [],
      anosafras: [],
      anosafra: [],
      salesmanName: [],
      goalTypes: [],
      seed_coordinateds: [],
      seed_managers: [],
      jobAssociatedUsers: [],
      groups: [],
      tableData: [],
      lastEdition: new Date(),
      dateLimit: [],
      tableName: ['Meta', 'Meta + Saldo em Carteira', 'Meta Estratégica', 'Meta Estratégica + Saldo em Carteira', 'TODAS'],
      loadingSalesmen: false,
      loadingManager: false,
      isLoading: false,
      salesmen_type: "",
      currentUser: {},
      showVersionsSelect: false,
      goalTypeMapping: {
        "Meta": "goal",
        "Meta + Saldo em Carteira" : "goal_plus_balance",
        "Meta Estratégica" : "strategic_goal",
        "Meta Estratégica + Saldo em Carteira" : "strategic_goal_plus_balance",
      },
      loadingPdf: false,
      loadingExcel: false
    };
  },
  methods: {
    generateReportByVersion(reportData) {
      this.tableData = reportData;
    },
    async startDownloadXlsx() {
      this.loadingExcel = true;
      const isAllSelected = this.filter.tableName.includes("TODAS");
      const goalTypes = isAllSelected
          ? Object.values(this.goalTypeMapping)
          : this.filter.tableName.map(type => this.goalTypeMapping[type]);

      const params = this.requestParams
      params['goal_types'] = goalTypes

      try {
        // Start ajax file download
        
        const response = await this.$http.secured.get(`/api/v1/report/goals_xlsx`, {
          params: params,
          responseType: 'blob'
        })

        // Finish progress
        this.progress = 100

        // Starting file donwload
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank'
        link.setAttribute('download', "relatorio.xlsx");
        document.body.appendChild(link);
        link.click();

      } catch (error) {
        // this.failed = true
      } finally {
        this.loadingExcel = false;
      }
    },
    clearFilters() {
      this.filter.goalType = { label: 'Vendedores', value: 'salesman' }
      this.filter.mkt_manager = [],
      this.filter.coordinated = [],
      this.filter.seed_coordinated = [],
      this.filter.seed_manager = [],
      this.filter.manager = [],
      this.filter.salesman = [],
      this.filter.dateLimit = null
    },
    async generatePDF() {
      const isAllSelected = this.filter.tableName.includes("TODAS");
      const goalTypes = isAllSelected
          ? Object.values(this.goalTypeMapping)
          : this.filter.tableName.map(type => this.goalTypeMapping[type]);

      let response;
      this.loadingPdf = true;

      const params = this.requestParams
      params['goal_types'] = goalTypes
      
      try {
        response = await this.$http.secured.get("/api/v1/report/goals_pdf", { 
          params: params,
          responseType: "arraybuffer"
        });

        this.lastEdition = new Date();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", "Meta Financeira.pdf");
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingPdf = false;
      }
    },
    async generateReportBefore(save = false) {
      this.isLoading = true;
      let timeoutWarning = false;

      const startTime = Date.now();

      const timeout = setTimeout(() => {
        timeoutWarning = true;
        this.$toasted.show("A requisição está demorando muito para responder. Aguarde ou tente novamente em instantes", { type: "error", duration: 6000 });
      }, 100000);

      if (this.selectedGoalTypeValue === "manager" || this.selectedGoalTypeValue === "admin") {
        await this.generateReportAfter(save);
        clearTimeout(timeout);
        this.isLoading = false;
        return;
      }

      try {
        this.anosafra = {}

        const response = await this.$http.secured.get(`/api/v1/anosafra_user`, {
          params: {
            q: {
              salesman_id: this.filter.salesman.id,
              anosafra_id: this.filter.anosafra.id,
            },
          },
        });

        this.salesmen_type = response.data.anosafra_users[0].salesman_type;
        if (!this.filter.manager) this.filter.manager = [];

        await this.generateReportAfter(save);
      } catch (error) {
        console.error("Erro no generateReportBefore:", error);
      } finally {
        const elapsedTime = Date.now() - startTime;
        const minLoadingTime = 10000;

        const remainingTime = minLoadingTime - elapsedTime;
        if (remainingTime > 0) {
          await new Promise((resolve) => setTimeout(resolve, remainingTime));
        }

        this.isLoading = false;
        clearTimeout(timeout);
      }
    },
    async generateReportAfter(save = false) {
      const params = this.requestParams

      if (save) params['save_report'] = true;

      try {
        const response = await this.$http.secured.get("/api/v1/report/goals", {
          params: params
        })

        this.anosafra = this.filter.anosafra;
        this.lastEdition = new Date();
        this.tableData = response.data;
        this.salesmanName = this.tableData.map(item => item.user);
      } catch (error) {
        console.error("Erro ao gerar Relatório", error)
      } finally {
        this.isLoading = false;
      }
    },
    getSummaries(param) {
      if(!Object.keys(param).length) return;

      var { columns, data } = param;
      var sums = [];

      for (const index in columns) {
        if (index == 0) {sums[index] = 'TOTAL'; continue;}

        var values = data.map(item => Number(item[columns[index].property]));
        
        if(index == (columns.length - 1)){
          if(sums[1] !== 0) {
            sums[index] = 100.0 * (parseFloat(sums[2]) / parseFloat(sums[1]))
          }else {
            sums[index] = 0.0
          }
          sums[index] = sums[index].toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
          continue
        }

        sums[index] = values.reduce((prev, curr) => (Number(curr) || 0 ) + prev, 0)
        // sums[index] = sums[index].toLocaleString("pt-BR", {style: "currency", currency: "brl"})
      }
      // Aqui é que está bugando
      sums[1] = parseFloat(sums[1]).toLocaleString("pt-BR", {style: "currency", currency: "brl"})
      sums[2] = parseFloat(sums[2]).toLocaleString("pt-BR", {style: "currency", currency: "brl"})

      return sums
    },
    async getJobAssociatedUsers(job_association_category = null) {
      this.isLoadingSeedManagers = true;
      try {
        const params = { unpaged: true, q: { is_seed_manager: true } }

        if (this.filter.anosafra) params.q.anosafra_id = this.filter.anosafra.id;
        if (job_association_category) params.q.job_association_category = job_association_category;
        
        const response = await this.$http.secured.get("/api/v1/users/", { params: params })

        this.jobAssociatedUsers = response.data;

        if (this.$currentUser().is_admin) return;
        if (!this.jobAssociatedUsers.map(el => el.id).includes(this.$currentUser().id)) return;
        
        this.jobAssociatedUsers = this.jobAssociatedUsers.filter((user) => user.id == this.$currentUser().id)
      } catch(error) {
        this.setError(error, "Something went wrong");
      } finally {
        this.isLoadingSeedManagers = false;
      }
    },
    initSalesmen() {
      var data = {
        name_only: true,
        q: {is_salesman: true, status: this.active}
      }

      this.loadingSalesmen = true

      if (this.currentUser.is_manager && !this.currentUser.is_admin) data.q['manager_id'] = this.currentUser.id
      if (this.filter.manager && this.filter.manager.coordinated_id) data.q["manager_id"] = this.filter.manager.coordinated_id;
      if (this.filter.anosafra && this.filter.anosafra.id) data.q['anosafra_id'] = this.filter.anosafra.id
      if (this.selectedGoalTypeValue === 'manager' && this.filter.manager.id) data.q['manager_id'] = this.filter.manager.id

      this.$http.secured
        .get("/api/v1/users", {params:data})
        .then((response) => {
          this.salesmen = response.data
          this.filteredSalesmen = this.salesmen
          this.loadingSalesmen = false
        })
        .catch(() => this.loadingSalesmen = false);
    },
    initManagers(){
      this.loadingManager = true
      this.$http.secured
        .get("/api/v1/users", {params: {unpaged: true, q: {is_manager: true, anosafra_id: this.filter.anosafra ? this.filter.anosafra.id : null, status: this.active}}})
        .then((response) => {
          this.allManagers = response.data
          this.filteredManager = this.allManagers
          this.loadingManager = false
        });
    },
    initCoordinated(){
      this.isLoadingCoordinators = true 
      this.$http.secured
        .get("/api/v1/users", { params: { unpaged: true, q: { is_coordinator: true, anosafra_id: this.filter.anosafra ? this.filter.anosafra.id : null, status: this.active}}})
          .then((response) => {
            this.coordinateds = response.data
            this.isLoadingCoordinators = false 
          });
    },
    initGoalTypes() {
      if (this.$currentUser().is_admin || this.$currentUser().is_manager) {
        this.goalTypes = [
          { label: 'Vegetal', value: 'admin' },
          { label: 'Gerente de Negócios', value: 'mkt_manager' },
          { label: 'Gerente de Sementes HF', value: 'grocery_manager' },
          { label: 'Gerente de Sementes de Cereais', value: 'grain_manager' },
          { label: 'Gerente de Nutrição', value: 'nutrition_manager' },
          { label: 'Gerente de Irrigação', value: 'irrigation_manager' },
          { label: 'Gerentes Comerciais', value: 'manager' },
          { label: 'Vendedores', value: 'salesman' }
        ]
      } else {
        this.goalTypes = { label: 'Vendedores', value: 'salesman' }
      }
    },
    initGroups() {
      this.$http.secured
        .get("/api/v1/grupos")
        .then((response) => (this.groups = response.data));
    },
    populateLimit(value) {
      this.dateLimit = this.dateRange(value.start_date, value.end_date);
    },
    numberFormatter(row, column, value) {
      if (!value) return 0;

      return value.toFixed(2);
    },
    userInfo(data){
      var title = ''
      var name = ''

      if (data.manager && this.selectedGoalTypeValue == 'manager') {
        title =  'GESTOR'
      } else if (this.selectedGoalTypeValue != 'admin') {
        title = 'VENDEDOR'
      }

      if(data.user) name = data.user.name

      return title ? `${title} - ${name}` : `${name}`
    },
    filterSalesmen(manager) {
      this.filteredSalesmen = manager ? manager.salesmans : []
    },
    filterManager(mkt_manager) {
      this.filteredManager =  mkt_manager && mkt_manager.managers ? this.allManagers.filter(f => mkt_manager.managers.includes(f.id)) : []
    },
    filterCoordinated(coordinated) {
      this.filteredManager = coordinated && coordinated.managers ? this.allManagers.filter(f => coordinated.managers.includes(f.id)) : []
    },
    dateRange(startDate, endDate) {
      var start = startDate.split("-");
      var end = endDate.split("-");
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          var j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          var month = j + 1;
          var displayMonth = month < 10 ? "0" + month : month;
          dates.push(["01", displayMonth, i].join("/"));
        }
      }
      return dates;
    },
    limitText(count) { 
      return `+ ${count}`;
    },
    initUsers() {
      this.initSalesmen();
      this.initManagers();
      this.initCoordinated();
    },
  },
  computed: {
    selectedGoalTypeValue() {
      if (!this.filter.goalType) return null;

      return this.filter.goalType.value;
    },
    jobAssociatedType() {
      return ['grocery_manager', 'irrigation_manager', 'grain_manager', 'nutrition_manager', 'mkt_manager'].includes(this.filter.goalType.value)
    },
    setting_image() {
      return this.$store.state.imageSettings || {}
    },
    isButtonDisabled() {
      const requiredFields = [this.filter.goalType, this.filter.tableName, this.filter.anosafra];

      return requiredFields.some(field => !field || field.length === 0 || field.length === null);
    },
    setting_image() {
      return this.$store.state.imageSettings || {}
    },
    tableDataArray() {
      var value = this.tableData

      if(Array.isArray(this.tableData)) return value

      return [{
        user: this.filter.salesman || this.selectedGoalTypeValue == 'admin' ? {name: 'Vegetal'} : {},
        goals: value,
      }]

    },
    requestParams() {
      const params = {
        "goal[salesman_id]": this.filter.salesman && this.filter.salesman.length
          ? this.filter.salesman.map(el => el.id)
          : null,
        "goal[teable_name]": this.filter.tableName
          ? this.filter.tableName
          : null,
        "goal[manager_id]": this.filter.manager && this.filter.manager.length && this.selectedGoalTypeValue == 'manager'
          ? this.filter.manager.map(el => el.id)
          : null,
        "goal[coordinated_id]": this.filter.coordinated && this.filter.coordinated.length && this.selectedGoalTypeValue == 'coordinator'
          ? this.filter.coordinated.map(el => el.id)
          : null,
        "goal[anosafra_id]": this.filter.anosafra
          ? this.filter.anosafra.id
          : null,
        "anosafra": this.filter.anosafra.descricao,
        "goal[salesmen_type]": this.salesmen_type && this.salesmen_type
          ? this.salesmen_type
          : null,
        "goal[dateLimit]": this.filter.dateLimit
          ? this.filter.dateLimit
          : null,
        "filter[date_limit]": this.filter.dateLimit
          ? this.filter.dateLimit
          : null,
        "filter[manager_id]": this.filter.manager && this.filter.manager.length && this.selectedGoalTypeValue == 'manager'
          ? this.filter.manager.map(el => el.id)
          : null,
        "list_salesmen": ['manager','admin'].includes(this.selectedGoalTypeValue)
          ? true
          : null,
        "list_manager": ['mkt', 'coordinator'].includes(this.selectedGoalTypeValue)
          ? true
          : null,
      }

      if (this.jobAssociatedType) {
        const paramsKey = this.filter.goalType.value == 'mkt_manager'? "goal[mkt_manager_id]" : "goal[seed_manager_id]"

        params[paramsKey] = this.filter.seed_manager.map(el => el.id)
      }

      return params
    }
  },

  mounted() {
    // Pega o v-model da um push nas options, na posição 4 (TODAS)
    this.filter.tableName.push(this.options.tableName[4]);

    if (this.$can('index', 'user')){
      this.initUsers()
    }

    this.initGroups();
    this.initGoalTypes();
    this.currentUser = this.$currentUser()

    if (this.currentUser.is_manager){
      this.filter.manager = [this.currentUser]
    } else if (this.currentUser.is_mkt_manager){
      this.filter.mkt_manager = [this.currentUser]
    } else if (this.currentUser.is_salesman){
      this.filter.salesman = [this.currentUser]
      this.filter.manager = [this.currentUser.manager]
    }
  },
  watch: {
    "filter.anosafra": function () {
      if (this.$can('index', 'user')) {
        this.initUsers();
      }
    },
    'filter.manager': function() {
      if(this.$can('index', 'user')){
        this.initSalesmen("");
      }
    },
    'filter.goalType': function(goalType) {
      this.filter.seed_manager = []

      if (this.currentUser.is_admin) this.filter.manager = [];


      if (this.jobAssociatedType) {
        this.getJobAssociatedUsers(goalType.value);
        return
      }

      if (this.$can('index', 'user')){
        this.initManagers();
        this.initSalesmen();
        this.filter.salesman = []
      }
    },
  },
};
</script>
<style scoped lang="scss">
  .el-table__fixed,
  .el-table__fixed-right {
    background-color: white;
    text-align: center;
  }

  #tableId{
    width: 100%;
  }
</style>
